import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Autocomplete,
  TextField,
} from "@mui/material";
import { Box } from "@mui/system";
import { DataGridPro, GridColDef } from "@mui/x-data-grid-pro";

// --- rows (your JSON data) ---
const rows = [
  {
    id: 1,
    keywordname: "UK sports",
    matchType: "Broad",
    campaignName: "Sport | UK | EN | Tier 5 Offers | TCPA | FTD",
    lastSeen: "21/07/25",
    imp: "213,456",
    Clicks: "12,000",
    Cost: "1,999",
    CVR: "100.00",
    OtherKeywords: "2",
  },
  {
    id: 2,
    keywordname: "best betting uk",
    matchType: "Broad",
    campaignName: "Sport | UK | EN | Tier 5 Offers | TCPA | FTD",
    lastSeen: "01/07/25",
    imp: "12,000",
    Clicks: "1,200",
    Cost: "899",
    CVR: "85.50",
    OtherKeywords: "3",
  },
  {
    id: 3,
    keywordname: "gambling",
    matchType: "Exact",
    campaignName: "Sport | IE | EN | Comparison 1 | TCPA | FTD",
    lastSeen: "08/07/25",
    imp: "300",
    Clicks: "90",
    Cost: "120",
    CVR: "70.00",
    OtherKeywords: "5",
  },
  {
    id: 4,
    keywordname: "betting sites uk",
    matchType: "Broad",
    campaignName: "Sport | UK | EN | Tier 5 Offers | TCPA | FTD",
    lastSeen: "13/07/25",
    imp: "7,800",
    Clicks: "1,050",
    Cost: "650",
    CVR: "76.30",
    OtherKeywords: "245",
  },
  {
    id: 5,
    keywordname: "online betting",
    matchType: "Exact",
    campaignName: "Sport | IE | EN | Comparison 1 | TCPA | FTD",
    lastSeen: "17/07/25",
    imp: "10,400",
    Clicks: "2,000",
    Cost: "1,250",
    CVR: "95.00",
    OtherKeywords: "124",
  },
];

// Example options for the autocomplete
const definitionOptions = [
  { label: "High Intent", value: "high_intent" },
  { label: "Returning Visitors", value: "returning_visitors" },
  { label: "Promo Seekers", value: "promo_seekers" },
  { label: "All Visitors", value: "all_visitors" },
];

const OtherKeywordST = ({ open, rowData, onClose }: any) => {
  // --- Define columns ---
  const columns: GridColDef[] = [
    {
      field: "keywordname",
      headerName: "Keyword Name",
      flex: 1,
      minWidth: 160,
    },
    {
      field: "matchType",
      headerName: "Match Type",
      flex: 0.6,
      minWidth: 110,
    },
    {
      field: "campaignName",
      headerName: "Campaign Name",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "lastSeen",
      headerName: "Last Seen",
      flex: 0.6,
      minWidth: 110,
    },
    {
      field: "imp",
      headerName: "IMP",
      flex: 0.6,
      minWidth: 110,
    },
    {
      field: "Clicks",
      headerName: "Clicks",
      flex: 0.6,
      minWidth: 110,
    },
    {
      field: "Cost",
      headerName: "Cost",
      flex: 0.6,
      minWidth: 110,
    },
    {
      field: "CVR",
      headerName: "CVR (%)",
      flex: 0.6,
      minWidth: 110,
    },
    {
      field: "OtherKeywords",
      headerName: "Other Keywords",
      flex: 1,
      minWidth: 180,
      renderCell: (params) => (
        <Typography variant="body2">{params.value}</Typography>
      ),
    },
    {
      field: "Definition",
      headerName: "Definition",
      flex: 0.8,
      minWidth: 160,
      sortable: false,
      renderCell: () => (
        <Autocomplete
          size="small"
          options={definitionOptions}
          getOptionLabel={(option) => option.label}
          sx={{ width: "100%" }}
          renderInput={(paramsInput) => (
            <TextField
              {...paramsInput}
              placeholder="Select..."
              variant="standard"
              color="secondary"
              InputProps={{
                ...paramsInput.InputProps,
                disableUnderline: true, // 🔑 hides underline
              }}
            />
          )}
        />
      ),
    },
  ];

  if (!rowData) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>
        Other Keywords Related to the Search term: best betting{" "}
      </DialogTitle>
      <DialogContent>
        <Box sx={{ width: "100%", display: "grid" }}>
          <DataGridPro
            sx={{
              "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
                outline: "none",
              },
              "& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within":
                { outline: "none" },
              "& .MuiDataGrid-cellEmpty": {
                width: "auto",
                overflow: "hidden",
                textOverflow: "ellipsis",
              },

              // row selection only once
              "& .MuiDataGrid-row.Mui-selected": {
                backgroundColor: "rgba(156, 39, 176, 0.08) !important",
                "&:hover": {
                  backgroundColor: "rgba(156, 39, 176, 0.16) !important",
                },
              },

              "& .MuiDataGrid-row.Mui-selected .MuiDataGrid-cell--pinnedLeft": {
                backgroundColor: "#f0def3 !important",
              },
              "& .MuiDataGrid-row.Mui-selected:hover .MuiDataGrid-cell--pinnedLeft":
                {
                  backgroundColor: "#e6d6e9ff !important",
                },

              // pinned RIGHT
              "& .MuiDataGrid-row.Mui-selected .MuiDataGrid-cell--pinnedRight":
                {
                  backgroundColor: "#f0def3 !important",
                },
              "& .MuiDataGrid-row.Mui-selected:hover .MuiDataGrid-cell--pinnedRight":
                {
                  backgroundColor: "#e6d6e9ff !important",
                },
              // make pinned cells transparent → let row bg show through
              "& .MuiDataGrid-cell--pinnedLeft, & .MuiDataGrid-cell--pinnedRight":
                {
                  backgroundColor: "#ffffff",
                },

              // remove extra blue tint on single cell select
              "& .MuiDataGrid-cell.Mui-selected": {
                backgroundColor: "inherit !important",
              },

              "& .MuiCheckbox-root": {
                color: "#9c27b0 !important",
              },
              "& .MuiCheckbox-root.Mui-checked": {
                color: "#9c27b0",
              },
              border: "none",
            }}
            density="compact"
            hideFooter
            //   disableMultipleRowSelection
            pagination={false}
            rows={rows}
            columns={columns}
            disableColumnMenu
            disableColumnFilter
            disableColumnReorder
            sortingOrder={["asc", "desc"]}
            isCellEditable={() => false}
            disableRowSelectionOnClick
            initialState={{
              pinnedColumns: {
                left: ["searchTerm", "matchType"],
                right: ["Definition"],
              },
            }}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ padding: "0px 20px 16px" }}>
        <Button color="secondary" variant="outlined" onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default OtherKeywordST;
